import * as React from 'react';

import { ESorting } from '../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { trackSortingChange } from './tracking';
import { getSortingNames } from '../../utils/sorting';

import * as styles from './Sorting.css';
import { Button, Outside, Popover, IconSort16, IconSuccess16, UIText2 } from '@cian/ui-kit';

export interface ISortingProps {
  onSelect(key: string): void;
  regionHasRoads: boolean;
  regionHasStations: boolean;
  regionId: number;
  sorting: ESorting;
}

export interface ISortingState {
  isDropdownOpen: boolean;
}

export class Sorting extends React.Component<ISortingProps, ISortingState> {
  public state = {
    isDropdownOpen: false,
  };

  private buttonRef = React.createRef<HTMLButtonElement>();
  private contentRef = React.createRef<HTMLDivElement>();

  public render() {
    const { regionId, regionHasRoads, regionHasStations, sorting } = this.props;
    const { isDropdownOpen } = this.state;
    const sortingParams = {
      regionHasRoads,
      regionHasStations,
      regionId,
    };
    const sortingNames = getSortingNames(sortingParams);

    return (
      <div className={styles['container']}>
        <Outside onOutside={this.close} insideRefs={[this.buttonRef, this.contentRef]}>
          <Popover
            placement="bottom-start"
            open={isDropdownOpen}
            content={
              <div ref={this.contentRef} className={styles['content']}>
                {Object.keys(sortingNames).map(key => (
                  <div key={key} className={styles['item']} onClick={() => this.handleClickOnItem(key)}>
                    {key === sorting && (
                      <div className={styles['item-icon']}>
                        <IconSuccess16 display="block" color="primary_100" />
                      </div>
                    )}
                    <UIText2>{sortingNames[key]}</UIText2>
                  </div>
                ))}
              </div>
            }
          >
            <Button
              ref={this.buttonRef}
              size="XS"
              theme="fill_white_primary"
              data-name="SortButton"
              beforeIcon={<IconSort16 color="primary_100" />}
              onClick={this.handleClickOnLink}
            >
              {sortingNames[sorting]}
            </Button>
          </Popover>
        </Outside>
      </div>
    );
  }

  private close = () => {
    this.toggle(false);
  };

  private toggle = (isDropdownOpen = !this.state.isDropdownOpen) => {
    this.setState({ isDropdownOpen });
  };

  private handleClickOnLink = () => {
    this.toggle();
  };

  private handleClickOnItem = (item: string) => {
    if (this.props.sorting === item) {
      return this.close();
    }
    trackSortingChange(item);
    this.props.onSelect(item);
    this.close();
  };
}
